/** 修理依頼起票 */
const RegisterModal = {
  /** 修理依頼 No. */
  RMA_NO: 15,
  /** シリアル No. */
  SERIAL_NO: 20,
  /** オーナー */
  OWNERSHIP: 256,
  /** お客様名 */
  CUSTOMER: 64,
  /** 貸出先顧客 */
  ORIGINAL_CUSTOMER: 64,
  /** 優先度 */
  CUSTOMER_PRIORITY: 20,
  /** ディストリビューター */
  DISTRIBUTOR: 128,
  /** 保守契約 */
  CONTRACT_NUMBER: 40,
  /** 顧客指摘 */
  CUSTOMER_COMMENT: 512,
};

/** 診断・検査結果入力 */
const Inspection = {
  /** 検査者名 */
  INSPECTOR_NAME: 40,
  /** メモ */
  MEMO: 400,
};

/** 水没気密検査 */
const WetLeakTest = {
  /** メモ */
  MEMO: 128,
};

/** 先端部画像 */
const DtaImage = {
  /** メモ */
  MEMO: 128,
};

/** 確定診断 */
const ConfirmedInspection = {
  /** 評価結果 */
  EVALUATION_RESULT: 1280,
  /** お客様への申し送り事項 */
  NOTES_TO_CUSTOMER: 1280,
  /** 質問横のテキスト */
  QUESTION_TEXT: 512,
  /** ファイルアップロードのコメント */
  FILE_UPLOAD_COMMENT: 32,
};

/** テンプレート管理 */
const ManageTemplate = {
  /** ドキュメントNo */
  DOCUMENT_NO: 32,
  /** テンプレート名 */
  TEMPLATE_NAME_LANG: 128,
};

/** ユーザー管理 */
const ManageUser = {
  /** ユーザーID */
  USER_ID: 20,
  /** 名前 */
  NAME: 40,
  /** パスワード */
  PASSWORD: 128,
  /** パスワード確認 */
  CONFIRM_PASSWORD: 128,
};

/** 組織管理 */
const ManageOrganization = {
  /** ID */
  ID: 32,
  /** 名前 */
  NAME: 128,
  /** 略称 */
  SHORT_NAME: 128,
};

/** 診断項目管理 */
const ManageInspectionItem = {
  /** 大項目名 */
  CATEGORY_NAME: 128,
  /** 中項目名 */
  TYPE_NAME: 128,
  /** NGサンプルのラベル名 */
  NG_SAMPLE_NAME: 128,
  /** 小項目名 */
  ITEM_NAME: 128,
  /** 診断基準テキスト */
  CRITERIA_TEXT: 128,
  /** メモ */
  MEMO: 128,
};

export const MaxLength = {
  RegisterModal,
  Inspection,
  WetLeakTest,
  DtaImage,
  ConfirmedInspection,
  ManageTemplate,
  ManageUser,
  ManageOrganization,
  ManageInspectionItem,
};
